// extracted by mini-css-extract-plugin
export default {"item":"o20Ct1","a":"U6oTip","name":"qGWCzd","img":"vEMdht","type":"c61Jvm"};